import { UserWorkspaceRole } from "../userWorkspaceRoles";

export function getPrimaryAdminFromAssignments<
    T extends { role: UserWorkspaceRole },
>(assignments: T[]): T | undefined {
    return assignments.find(
        (assignment) => assignment.role === UserWorkspaceRole.PRIMARY_ADMIN,
    );
}

export function getPrimaryAdminUserIdFromAssignments(
    assignments: Array<{
        role: UserWorkspaceRole;
        userId?: number;
        user?: { id: number } | null;
    }>,
): number | null {
    const primaryAdminAssignment = getPrimaryAdminFromAssignments(assignments);
    return (
        primaryAdminAssignment?.userId ??
        primaryAdminAssignment?.user?.id ??
        null
    );
}
